export const validation = {
  labelMaxChar: 25,
  copyrightMaxChar: 100,
  socials: {
    min: 0,
    max: 7
  },
  footerLogo: 1
}
